module.exports = __webpack_public_path__ + "img/welcome_2.c6d7b035.jpg";